import axios from "axios";
import { PDFDocument } from "pdf-lib";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Pages in a label file the tenant is about to upload (an image counts as one); null when it cannot be read.
export async function countLabelPages(file) {
  if (file.type !== "application/pdf") return 1;
  try {
    return (await PDFDocument.load(await file.arrayBuffer(), { ignoreEncryption: true })).getPageCount();
  } catch {
    return null;
  }
}

// A blob URL runs in this app's origin, so only types that cannot carry script are opened.
const PRINTABLE_TYPES = ["application/pdf", "image/png", "image/jpeg", "image/webp"];

async function fetchLabelBlob(url) {
  const fullUrl = url.startsWith("http") ? url : `${BACKEND}${url}`;
  const { data } = await axios.get(fullUrl, { withCredentials: true, responseType: "blob" });
  const type = (data.type || "").split(";")[0].trim().toLowerCase();
  if (!PRINTABLE_TYPES.includes(type)) {
    throw new Error(`Label file type not allowed: ${type || "unknown"}`);
  }
  return new Blob([data], { type });
}

// Opens one label file in a new tab and prints right away; returns false when a pop-up was blocked.
export async function printLabelFile(url) {
  const blobUrl = URL.createObjectURL(await fetchLabelBlob(url));
  const win = window.open(blobUrl, "_blank");
  if (!win) {
    URL.revokeObjectURL(blobUrl);
    return false;
  }
  win.addEventListener("load", () => setTimeout(() => win.print(), 800));
  setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
  return true;
}
